'use client';

import TranslatedText from '@storefront/shared-components/translated-text/translated-text';
import { useTranslation } from 'react-i18next';
import { NamespacesI18n } from '@storefront/i18n';
import { uiEvents } from '@storefront/services/DataCollection/simpleUiEvents';
import { useEffect, useRef, useState } from 'react';
import { useIntersection } from '@storefront/hooks/useIntersection';
import DataCollection from '@storefront/services/DataCollection';
import { FlowType } from '@storefront/app/flow-orchestrator/types';
import { Disclaimers as DisclaimersV2 } from '@monetization/hpaip-components-library';
import { getTranslatedComponents } from './disclaimer-utils';

interface DisclaimerProps {
  searchParams: {
    skus: string;
    pdpFlow: FlowType;
  };
}

type test = {
  key: string;
  value: string;
};

export function Disclaimers({ searchParams }: Readonly<DisclaimerProps>) {
  const [triggerAnalyticsDisclaimerOnce, setTriggerAnalyticsDisclaimerOnce] =
    useState(true);

  const { t } = useTranslation(NamespacesI18n.PDP_CONFIG);
  const disclaimerRef = useRef(null);
  const disclaimerInViewport = useIntersection(disclaimerRef, '0px');
  const flowType = searchParams?.pdpFlow;

  useEffect(() => {
    const productAnalytics = uiEvents.disclaimerPrinterSD;
    if (disclaimerInViewport && triggerAnalyticsDisclaimerOnce) {
      DataCollection.sendEvent(productAnalytics);
      setTriggerAnalyticsDisclaimerOnce(false);
    }
  }, [disclaimerInViewport]);

  const translatedComponents = getTranslatedComponents(t);
  const disclaimerType = flowType === FlowType.Pc ? 'pc' : 'printer';
  let iterableDisclaimer: test[] = [];
  const disclaimer = t(`disclaimers.${disclaimerType}`, {
    returnObjects: true,
  });
  if (
    disclaimer != null &&
    typeof disclaimer === 'object' &&
    Object.keys(disclaimer).length > 0
  )
    iterableDisclaimer = Object.keys(disclaimer).map((key) => ({
      key,
      value: (disclaimer as Record<string, string>)[key],
    }));
  /// v2 does not have paragraph01
  const disclaimerV2 = iterableDisclaimer.filter(
    (item) => item.key !== 'paragraph01'
  );
  return (
    <DisclaimersV2
      disclaimerTitle={t('modals.modalDisclaimer.disclaimer')}
      sortedDisclaimers={disclaimerV2}
      TranslationWrapperComponent={TranslatedText}
      translationComponents={translatedComponents}
    />
  );
}
